import React from "react";
import OfferCard from "../../components/cards/OfferCard";
import Icon from "../../components/Icon";
import {
  faArrowUpFromBracket,
  faCheck,
  faLocationDot,
  faStar,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import Male from "../../assets/images/male.png";
import MobileHeader from "../../layout/MobileHeader";
import Hero from "../../assets/images/hero.png";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";
import ReviewCard from "../../components/cards/ReviewCard";
import GuideForm from "../Guide/GuideForm";
import Share from "../../components/elements/Share";


const GuideDetails = ({ guide = {} }) => {

  return (
    <>
      <MobileHeader placeholder="saerch for puja/hawan"  height={"237px"}>
        <MobileHeaderSearch placeholder="Search Guide" />
      </MobileHeader>
      <section className="px-4  " style={{ marginTop: "270px" }}>
        <div className="">
          <p className="top-heading mb-0">Know Your Guide</p>
          <p className="fs-8 mb-0">{ guide.cityId?.name }</p>
        </div>

        <div className="row mt-3">
          <div className="col-md-12 p-0">
            <div className="d-flex ">
              <img
                src={guide.file?.Url || Male}
                className="rounded-4 me-3 mb-3"
                style={{ width: "80px", height: "80px" }}
              />

              <div className="d-flex ">
                <div className="">
                  <p className="top-heading py-1 mb-0">{ guide.name }</p>
                  <p className="mb-0 text-muted fs-8">{ guide.cityId?.name  }</p>
                  <div className="d-flex align-items-center">
                  {
                        Array(5).fill(0).map((_, i) =>
                            <Icon icon={faStar} className={`${ i+1 <= guide.rating ? "text-warning" : "text-secondary"} me-1 fs-9`} />
                        )
                    }
                    <p className="mb-0 fs-8 text-muted bold">{ guide.rating }/5</p>
                  </div>
                  <p className="text-saffron my-1">₹240/hr</p>
                </div>
                <div className="">
                  <Share title={guide.name} text={guide.shareDescription || guide.about} />
                </div>
              </div>
            </div>
            <div className="w-100">
              <p className="custom-text-color fs-8 mb-0">
                <Icon icon={faLocationDot} className="text-saffron me-3" />{" "}
                { guide?.address }
              </p>
              <div className="my-2">
                {
                  guide.languages?.map((lang, i) => 
                    <p className="mb-0"><Icon icon={lang.isKnow ? faCheck : faXmarkCircle} className={lang.isKnow ? "text-success" : "text-danger"} /> { lang.name }</p>
                  )
                }
              </div>


              <p className="fs-8">
                { guide.about }
              </p>
            </div>

            {/* booking */}

            <GuideForm guide={guide}/>

            <h6 className="custom-text-color my-4">Top Visits:</h6>


            <div className="card rounded-4 p-3">
              <div className="d-flex flex-wrap">
                {
                  Array(6).fill(0).map(_ =>
                    <div className="d-flex m-2">
                      <div style={{ width: "65px", height: "40px" }}>
                        <img src={Hero} className="w-100 h-100 rounded" />
                      </div>
                      <div className="d-flex flex-column ms-2">
                        <p className="bold mb-0 fs-8">{"Harjis Garden"}</p>
                        <p className="fs-8 mb-0">{"650m"}</p>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>

            <div className="d-flex align-items-center mt-5 mb-3">
              <h4 className="custom-text-color me-4 mb-0">Reviews</h4>
              <select
                className="form-control w-75"
                style={{ borderRadius: "20px" }}
              >
                <option>Sort By: Most Relevant</option>
                <option>Sort By: high to low</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row mt-4 flex-nowrap scrollbar-hidden">
          {Array(5).fill().map(()=><div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                            <ReviewCard />
                        </div>)}
        </div>
        <hr />
        <p className="custom-text-color my-4">Must Have While Travelling</p>

        <ul>
          <li>
            <p className="custom-text-color">
              Passport, Aadhar, Driving License, and Govt ID are accepted as ID
              Proof
            </p>
          </li>
          <li>
            <p className="custom-text-color">Lorem Ipsum Filter</p>
          </li>
          <li>
            <p className="custom-text-color">Lorem Ipsum Filter</p>
          </li>
          <li>
            <p className="custom-text-color">Lorem Ipsum Filter</p>
          </li>
        </ul>

        <hr />
        {/* offers */}
        <div className="offers px-0 mt-5">
          <div className="row mx-0  ">
            <div className="col-md-8 p-0">
              <div className="top-heading">Offers Tailored For You</div>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
              <div className="view-all w-50">Know More</div>
            </div>
          </div>

          <div className="row p-0 mx-0 my-3 ">
            <ul className="list-unstyled d-flex offers-card-list-mobile p-0 mobileScrollBar">
              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Get upto 15% off on your First Booking"} />
                </div>
              </li>

              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Budget Friendly Homestays"} />
                </div>
              </li>
            </ul>

          </div>
        </div>
      </section>
    </>
  );
};

export default GuideDetails;
